export default __webpack_public_path__ + "static/media/17.3ffc97c8.webp";